<script lang="ts">
  import { resolve } from '$app/paths'
  import Heading from '$lib/components/ui/Heading.svelte'
  import Section from '$lib/components/ui/Section.svelte'
</script>

<Section spacing="first">
  <Heading size="xl">Privacy Policy</Heading>

  <div class="richtext">
    <p>
      At Pausly, accessible from <a href="https://www.pausly.app"
        >https://www.pausly.app</a
      >, one of our main priorities is the privacy of our visitors. This Privacy
      Policy document contains types of information that is collected and
      recorded by Pausly and how we use it.
    </p>
    <p>
      If you have additional questions or require more information about our
      Privacy Policy, do not hesitate to contact us.
    </p>
    <h1 id="-log-files-"><strong>Log Files</strong></h1>
    <p>
      Pausly follows a standard procedure of using log files. These files log
      visitors when they visit websites. All hosting companies do this and a
      part of hosting services&#39; analytics. The information collected by log
      files include internet protocol (IP) addresses, browser type, Internet
      Service Provider (ISP), date and time stamp, referring/exit pages, and
      possibly the number of clicks. These are not linked to any information
      that is personally identifiable. The purpose of the information is for
      analyzing trends, administering the site, tracking users&#39; movement on
      the website, and gathering demographic information.
    </p>
    <h1 id="-privacy-policies-"><strong>Privacy Policies</strong></h1>
    <p>
      You may consult this list to find the Privacy Policy for each of the
      advertising partners of Pausly.
    </p>
    <p>
      Third-party ad servers or ad networks uses technologies like cookies,
      JavaScript, or Web Beacons that are used in their respective
      advertisements and links that appear on Pausly, which are sent directly to
      users&#39; browser. They automatically receive your IP address when this
      occurs. These technologies are used to measure the effectiveness of their
      advertising campaigns and/or to personalize the advertising content that
      you see on websites that you visit.
    </p>
    <p>
      Note that Pausly has no access to or control over these cookies that are
      used by third-party advertisers.
    </p>
    <h1 id="-third-party-privacy-policies-">
      <strong>Third Party Privacy Policies</strong>
    </h1>
    <p>
      Pausly&#39;s Privacy Policy does not apply to other advertisers or
      websites. Thus, we are advising you to consult the respective Privacy
      Policies of these third-party ad servers for more detailed information. It
      may include their practices and instructions about how to opt-out of
      certain options.
    </p>
    <p>
      You can choose to disable cookies through your individual browser options.
      To know more detailed information about cookie management with specific
      web browsers, it can be found at the browsers&#39; respective websites.
    </p>
    <h1 id="-children-s-information-">
      <strong>Children&#39;s Information</strong>
    </h1>
    <p>
      Another part of our priority is adding protection for children while using
      the internet. We encourage parents and guardians to observe, participate
      in, and/or monitor and guide their online activity.
    </p>
    <p>
      Pausly does not knowingly collect any Personal Identifiable Information
      from children under the age of 13. If you think that your child provided
      this kind of information on our website, we strongly encourage you to
      contact us immediately and we will do our best efforts to promptly remove
      such information from our records.
    </p>
    <h1 id="-online-privacy-policy-only-">
      <strong>Online Privacy Policy Only</strong>
    </h1>
    <p>
      This Privacy Policy applies only to our online activities and is valid for
      visitors to our website with regards to the information that they shared
      and/or collect in Pausly. This policy is not applicable to any information
      collected offline or via channels other than this website.
    </p>
    <h1 id="-consent-"><strong>Consent</strong></h1>
    <p>
      By using our website, you hereby consent to our Privacy Policy and agree
      to its <a href={resolve('/legal/terms-of-service')}>Terms of Service.</a>
    </p>
  </div>
</Section>
